import { render, staticRenderFns } from "./DashboardSearch.vue?vue&type=template&id=15d862f4&scoped=true&"
import script from "./DashboardSearch.vue?vue&type=script&lang=js&"
export * from "./DashboardSearch.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSearch.vue?vue&type=style&index=0&id=15d862f4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d862f4",
  null
  
)

export default component.exports